<template>
  <div class="bay">
    <span class="pic"
      ><img
        :src="require(`@/assets/img/privateCruising/${image}`)"
        alt="&#12524;&#12452;&#12531;&#12508;&#12540;&#12502;&#12522;&#12483;&#12472;"
    /></span>
    <div class="bay__inner">
      <span class="name">{{ title }}</span>
      <span class="desc">{{ content }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
    title: String,
    content: String,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/molecules/privateCruising/bay.scss";
</style>
